export const ERROR_CODE = {
    VALIDATION_ERROR: 1,
    FILE_ERROR: 2,
    DATABASE_ERROR: 3,
    UPDATED: 4,
    NOT_EXIST: 5,
    NEED_ACCEPT_ENCODING: 6,
    TOKEN_INVALID: 100,
    NOT_AUTHORIZED: 101,
    ACCOUNT_LOCKED: 102,
    LOGIN_FAILURE: 103,
    AUTH_CODE_FAILURE: 104,
    UNKNOWN_ERROR: 999
} as const

export type ERROR_CODE = typeof ERROR_CODE[keyof typeof ERROR_CODE];